import React from "react";
import ReactDOM from "react-dom/client";
import { SpeedInsights } from "@vercel/speed-insights/react";
import "@/index.css";
import App from "@/App";
import { purgeLocalCrmCacheIfNeeded } from "@/config/bootstrap";

// Limpia cache demo local cuando se opera contra Supabase (antes de montar la app)
purgeLocalCrmCacheIfNeeded();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <SpeedInsights />
  </React.StrictMode>,
);
